import React, { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Layout, Menu, Button, theme, Flex, Typography } from "antd";
import { MenuItems } from "@/pages/Layout/Menu";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "@/redux/slices/authSlice";
import akLogo from "@/assets/akLogo.jpg";

const { Header, Sider, Content } = Layout;

const BasicLayout = () => {
	const dispatch = useDispatch();
	const location = useLocation();
	const { user } = useSelector((state) => state.auth);

	const [collapsed, setCollapsed] = useState(false);
	const [selectedMenu, setSelectedMenu] = useState("Home");
	const {
		token: { colorBgContainer },
	} = theme.useToken();

	const pathname = location.pathname.split("/")[1];
	let defaultSelectedKeys = pathname;
	if (pathname === "") {
		defaultSelectedKeys = "home";
	}
	// TODO: should use router to config dynamic route
	if (pathname === "allocationDetail") {
		defaultSelectedKeys = "allocations";
	}

	const handleLogout = () => {
		dispatch(logout());
		window.location.href = "/login";
	};

	const setMenu = (menuName) => {
		setSelectedMenu(menuName);
	};

	const updatedMenuItems = () => {
		return MenuItems.filter((item) => {
			if (item.allowedRole.includes(user.role)) {
				return true;
			}
			return false;
		});
	};

	const openSummary = () => {
		window.open('/latest-daily-summary', '_blank');
	}

	return (
		<Layout style={{ minHeight: 600 }}>
			<Sider
				theme="light"
				trigger={null}
				collapsible
				collapsed={collapsed}
				style={{ minHeight: "100vh" }}
			>
				<div className="demo-logo-vertical" />

				{/* Company Icon and Name */}
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						padding: "16px",
					}}
				>
					<img
						style={{ width: collapsed ? "40px" : "80px" }}
						src={akLogo}
						alt=""
					/>
					{!collapsed && (
						<span style={{ fontSize: "16px", fontWeight: "bold" }}>
							AK TRAVEL
						</span>
					)}
				</div>

				<Menu
					theme="light"
					mode="inline"
					defaultSelectedKeys={[defaultSelectedKeys]}
				>
					{updatedMenuItems().map((item) => (
						<Menu.Item
							key={item.key}
							icon={item.icon}
							onClick={() => setMenu(item.name)}
						>
							<Link to={item.link}>{item.name}</Link>
						</Menu.Item>
					))}
				</Menu>
			</Sider>
			<Layout>
				<Header
					style={{
						padding: 0,
						background: colorBgContainer,
						paddingRight: "20px",
					}}
				>
					<Flex justify="space-between" align="center" gap={"middle"}>
						<div>
							<Button
								type="text"
								icon={
									collapsed ? (
										<MenuUnfoldOutlined />
									) : (
										<MenuFoldOutlined />
									)
								}
								onClick={() => setCollapsed(!collapsed)}
								style={{
									fontSize: "20px",
									width: 64,
									height: 64,
								}}
							/>
							<span
								style={{ fontSize: "18px", fontWeight: "bold" }}
							>
								{selectedMenu.toUpperCase()}
								<Button style={{ marginLeft: "10px" }} onClick={() => openSummary()}>
									Summary
								</Button>
							</span>
						</div>

						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: "10px",
							}}
						>
							<Typography.Text>Hi {user.email}</Typography.Text>
							<Button onClick={handleLogout}>Logout</Button>
						</div>
					</Flex>
				</Header>
				<Content
					style={{
						margin: "16px 16px",
						padding: 12,
						minHeight: 280,
						background: colorBgContainer,
						overflowY: "scroll", // 允许内容垂直滚动
						maxHeight: "calc(100vh - 64px - 32px)", //
					}}
				>
					<Outlet />
				</Content>
			</Layout>
		</Layout>
	);
};

export default BasicLayout;
